import { IHistoryProvider, Answers, HistoryProviderOptions, HistoryMetaData } from "./IProvider";
import { deleteChatHistoryApi, getChatHistoryApi, getChatHistoryListApi, postChatHistoryApi } from "../../api";

export class CosmosDBProvider implements IHistoryProvider {
    getProviderName = () => HistoryProviderOptions.CosmosDB;

    private continuationToken: string | undefined;
    private isItemEnd: boolean = false;

    resetContinuationToken() {
        this.continuationToken = undefined;
        this.isItemEnd = false;
    }

    async getNextItems(count: number, idToken?: string, userId?: string): Promise<HistoryMetaData[]> {
        if (this.isItemEnd) {
            return [];
        }

        try {
            const response = await getChatHistoryListApi(count, this.continuationToken, idToken || "", userId || "");
            this.continuationToken = response.continuation_token;
            if (!this.continuationToken) {
                this.isItemEnd = true;
            }
            return response.sessions.map(session => ({
                id: session.id,
                title: session.title,
                timestamp: session.timestamp,
                patient_id: session.patient_id,
                total_tokens: session.total_tokens,
                estimated_cost: session.estimated_cost,
                query_count: session.query_count,
                total_backend_ms: session.total_backend_ms
            }));
        } catch (e) {
            console.error(e);
            return [];
        }
    }

    async addItem(id: string, answers: Answers, idToken?: string, entraUserId?: string, ehrUserId?: string, patientId?: string): Promise<void> {
        await postChatHistoryApi({ id, answers, user_id: entraUserId, ehr_user_id: ehrUserId, patient_id: patientId }, idToken || "");
    }

    async getItem(id: string, idToken?: string, userId?: string): Promise<Answers | null> {
        const response = await getChatHistoryApi(id, idToken || "", userId || "");
        return response.answers || null;
    }

    async deleteItem(id: string, idToken?: string, userId?: string): Promise<void> {
        await deleteChatHistoryApi(id, idToken || "", userId || "");
        return;
    }
}
